import { ENDPOINTS } from "@/api/endpoints";
import { apiClient } from "@/lib/client";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

const downloadJobStyles = async (jobId: number): Promise<Blob> => {
  return apiClient
    .get(`${ENDPOINTS.JOB_STYLES_EXCEL_DOWNLOAD(jobId.toString())}`)
    .blob();
};

export const useDownloadJobStylesQuery = (
  jobId: number | null,
  options?: Omit<UseQueryOptions<Blob, Error>, "queryKey" | "queryFn">
) => {
  return useQuery({
    queryKey: ["downloadJobStyles", jobId],
    queryFn: () => {
      if (jobId === null) {
        throw new Error("jobId is null");
      }
      return downloadJobStyles(jobId);
    },
    ...options,
  });
};
